import React, { useState, useEffect, useRef } from 'react';
import bee from '../assets/img/bee.gif';

function BeeFlyArround() {
  const [isPaused, setIsPaused] = useState(false);
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [direction, setDirection] = useState(1);

  const headingRef = useRef(0);
  const animationFrameRef = useRef(null);
  const timeoutRef = useRef(null);

  const SPEED = 3;
  const TURN_RANGE = 0.1;
  const BEE_WIDTH = 100;
  const BEE_HEIGHT = 100;

  // Handle mouse movement
  useEffect(() => {
    const handleMouseMove = () => {
      setIsPaused(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setIsPaused(false);
      }, 60000); // 1 minute = 60000ms
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  // Animate bee
  useEffect(() => {
    const animate = () => {
      if (!isPaused) {
        setPosition((prevPos) => {
          const { innerWidth, innerHeight } = window;

          headingRef.current += (Math.random() - 0.5) * TURN_RANGE;

          let dx = SPEED * Math.cos(headingRef.current);
          let dy = SPEED * Math.sin(headingRef.current);

          let newX = prevPos.x + dx;
          let newY = prevPos.y + dy;

          if (newX < 0 || newX + BEE_WIDTH > innerWidth) {
            headingRef.current = Math.PI - headingRef.current;
            newX = Math.max(0, Math.min(newX, innerWidth - BEE_WIDTH));
          }

          if (newY < 0 || newY + BEE_HEIGHT > innerHeight) {
            headingRef.current = -headingRef.current;
            newY = Math.max(0, Math.min(newY, innerHeight - BEE_HEIGHT));
          }

          setDirection(dx < 0 ? -1 : 1);
          return { x: newX, y: newY };
        });
      }

      animationFrameRef.current = requestAnimationFrame(animate);
    };

    animationFrameRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameRef.current);
  }, [isPaused]);

  const beeStyle = {
    position: 'fixed',
    left: position.x,
    top: position.y,
    width: `${BEE_WIDTH}px`,
    height: `${BEE_HEIGHT}px`,
    pointerEvents: 'none',
    zIndex: 9999,
    transform: `scaleX(${direction})`,
  };

  return (
    <>
      {!isPaused && (
        <div style={beeStyle}>
          <img src={bee} alt="Bee" style={{ width: '50%', height: '50%' }} />
        </div>
      )}
    </>
  );
}

export default BeeFlyArround;
